export default {
  PUSH_TESTS: 'PUSH_TESTS',
  SET_TESTS: 'SET_TESTS',
  SET_TESTS_FOR_GRADE: 'SET_TESTS_FOR_GRADE',
  UPDATE_TEST: 'UPDATE_TEST',
  DELETE_TEST: 'DELETE_TEST',
  START_TEST: 'START_TEST',
  GRADE_TEST: 'GRADE_TEST',
  FINISH_TEST: 'FINISH_TEST',
  RETRY_TEST: 'RETRY_TEST',
};
